import { FC, ReactNode } from "react";
import { styled } from "@mui/material";

interface Props {
  children?: ReactNode;
}

const StepContent: FC<Props> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default StepContent;

const Container = styled("div")`
  max-height: 690px;
  overflow: auto;
  padding: 0px 0.5rem;

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #bebebe;
  }
`;
